// Sidebar.js

import React from "react";
import { Drawer, List, ListItem, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";
import { styled } from '@mui/material/styles';

// Create styled NavLink component
const StyledNavLink = styled(NavLink)({
    textDecoration: 'none',
    color: '#2c3e50',
    width: '100%',
    '&:hover': {
        color: '#3498db',
    },
});

// Create styled ListItem component
const StyledListItem = styled(ListItem)({
    padding: '12px 24px',
    '&:hover': {
        backgroundColor: '#f5f5f5',
    },
});

const StyledListItemText = styled(ListItemText)({
    '& .MuiTypography-root': {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 500,
        fontSize: '1.1rem',
    },
});

const pages = [
    { name: "About Us", link: "/about-us"},
	{ name: "Map", link: "/map" },
    { name: "Upload File", link: "/admin" },
    { name: "Variable Manager", link: "/variables" },
    { name: "Login", link: "/login" },
];
const Sidebar = ({ toggleSideBar, handleLogout, isOpen, onClose }) => {
	return (
		<Drawer 
			open={isOpen} 
			onClose={onClose}
			PaperProps={{
				sx: {
					width: 250,
					paddingTop: '20px',
				}
			}}
		>
			<List>
				{pages.map((page) => (
					<StyledListItem key={page.name}>
						<StyledNavLink to={page.link} onClick={toggleSideBar}>
							<StyledListItemText primary={page.name} />
						</StyledNavLink>
					</StyledListItem>
				))}
				<StyledListItem>
					<StyledNavLink to="/map" onClick={handleLogout}>
						<StyledListItemText primary="Logout" />
					</StyledNavLink>
				</StyledListItem>
			</List>
		</Drawer>
	);
};

export default Sidebar;